// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: true,
  version: env.npm_package_version,
  build: 'production',
  serverUrl: 'https://edgeless.io',
  // serverUrl: 'https://www.edgeless.io',
  server: 'chewbacca.edgeless.io',
  multiplayServer: 'multiplay.edgeless.io',
  mutualBettingServer: 'mb.edgeless.io',
  serverPorts: {
    main: 443,
  },
  defaultLanguage: 'en',
  supportedLanguages: ['en', 'ru', 'kp', 'es', 'it'],
  auth0: {
    domain: 'edg.eu.auth0.com',
    clientID: '8pS9J9bf5KmfCGrsq2FG3YanibYZKKB0',
    realm: 'Username-Password-Authentication',
    audience: 'edgeless',
  },
  pusher: {
    clientId: '4e81e9b8cffb230f950a',
    cluster: 'eu',
    encrypted: true,
    authEndpoint: 'https://edgeless.io/api/pusher/authorize',
  },
  sentry: {
    dsn: 'https://da2bb2e0479f4e3792d170309e246702@sentry.io/306268',
    config: {
      environment: 'production',
      release: env.npm_package_version,
    },
  },
  analytics: {
    hotjarId: 1119511,
  },
  amplitude: {
    apiKey: '8b302a221552beb38746aaf492757ddd',
  },
  recaptchaEnabled: true,
  recaptchaKey: '6Lcayp0UAAAAAGJdsHRcz3nHLZt9YW9eC1b5g-pq',
  verifyPhone: false,
  pagesDomain: 'https://frame.edgeless.io',
  changellyMerchantId: '7y2we5ahtscq6kf0',
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/environments/environment.ts